<template>
  <div>
    <div class="col-sm-12">
      <el-table class="table table-striped table-no-bordered table-hover" ref="historyTable" :data="history"
        v-loading="paging" element-loading-spinner="qc-spinner" style="width: 100%" highlight-current-row
        @row-click="selectApplication" tooltip-effect="light">
        <el-table-column :width="70" v-if="checkboxCol == true">
          <template>
            <input type="checkbox">
          </template>
        </el-table-column>
        <el-table-column label="Created">
          <template slot-scope="props">
            <span :class="{'font-weight-bold': props.row.status == 'COMPLETED'}">{{formatDate(props.row.created)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="Submitted">
          <template slot-scope="props">
            <span :class="{'font-weight-bold': props.row.status == 'COMPLETED'}">{{props.row.submitted ? formatDate(props.row.submitted) : null}}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="isIndividual" :show-overflow-tooltip="true" label="Organisation">
          <template slot-scope="props">
            <span :class="{'font-weight-bold': props.row.status == 'COMPLETED'}">{{props.row.owner.name}}</span>
          </template>
        </el-table-column>
        <el-table-column v-else :show-overflow-tooltip="true" label="Applicant">
          <template slot-scope="props">
            <span :class="{'font-weight-bold': props.row.status == 'COMPLETED'}">{{props.row.applicant.name}}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="!isIndividual" :show-overflow-tooltip="true" label="">
          <template slot-scope="props">
            <span :class="{'font-weight-bold': props.row.status == 'COMPLETED'}">{{props.row.customerReference}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" :show-overflow-tooltip="true" label="Status">
          <template slot-scope="props">
            <span v-if="props.row.status == 'OPEN'" class="label label-wd label-plain text-plain"><i class="fa fa-pencil"></i>Open</span>
            <span v-else-if="props.row.status == 'PENDING'" class="label label-wd label-plain"><i class="fa fa-clock-o"></i>Pending</span>
            <span v-else-if="props.row.status == 'APPLICANT_ACTION'" class="label label-wd label-plain"><i class="fa fa-clock-o"></i>Pending<br /><span style="font-size: 80%;">(Applicant Action Required)</span></span>
            <span v-else-if="props.row.status == 'COMPLETED'" class="font-weight-bold label label-wd label-plain text-success">
              <i class="fa fa-check text-success"></i>Completed
              <br />
              <span style="font-size: 80%;">({{formatDate(props.row.completed)}})</span>
            </span>
            <span v-else-if="props.row.status == 'ARCHIVED'" class="label label-wd label-plain"><i class="fa fa-folder-open-o"></i>Archived</span>
            <span v-else>{{props.row.result}}</span>
          </template>
        </el-table-column>
        <el-table-column :min-width="40" fixed="right" align="right" :show-overflow-tooltip="true" label="Verifications">
          <template slot-scope="props">
            <span :class="{'font-weight-bold': props.row.status == 'COMPLETED'}">{{props.row.verificationCount}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="showPagination" class="col-sm-6 pagination-info">
      <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
    </div>
    <div v-if="showPagination" class="col-sm-6">
      <p-pagination class="pull-right" v-model="pagination.currentPage" :per-page="pagination.perPage"
        :total="pagination.total">
      </p-pagination>
    </div>
  </div>
</template>
<script>

import PPagination from 'src/components/Pagination.vue'

import moment from 'moment'
import _ from 'lodash'
import { mapState, mapGetters } from 'vuex'
import EventBus from '../../../bus'

export default {
  name: "application-history-table",
  components: {
    PPagination
  },
  props: {
    query: { type: String, default: "" },
    status: { type: Array, default: () => { return [] } },
    dateRange: { type: Array, default: () => { return [] } },
    customFilters: { type: Array, default: () => { return [] } },
    customerReference: { type: String, default: "" },
    size: { type: Number, default: 20 },
    showPagination: { type: Boolean, default: true }
  },
  data() {
    return {
      result: null,
      history: null,
      paging: false,
      checkboxCol: false,
      total: 0,
      pagination: {
        perPage: 20,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
    }
  },
  mounted() {
    this.getHistory()
    this.checkboxCol = false
    this.$store.state.applicantSelectedRows = []
  },
  activated() {
    this.getHistory()
  },
  watch: {
    applicantCheckboxStatus: function (val) {
      this.checkboxCol = val
    },
    reloadApplicantHistoryTable: function (val) {
      if(val == true) {
        this.getHistory()
        this.$store.state.reloadApplicantHistoryTable = false
        this.$store.state.applicantCheckboxArchive = false
      }
    },
    query: _.debounce(function (value) {
      this.pagination.currentPage = 1
      this.getHistory()
    }, 500),
    status(value) {
      this.pagination.currentPage = 1
      this.getHistory()
    },
    customerReference(value) {
      this.pagination.currentPage = 1
      this.getHistory()
    },
    dateRange(value) {
      this.pagination.currentPage = 1
      this.getHistory()
    },
    paginationCurrentPage(value) {
      this.getHistory()
    },
    paginationPerPag(value) {
      this.getHistory()
    }
  },
  computed: {
    ...mapState(["applicantCheckboxArchive", "reloadApplicantHistoryTable"]),
    ...mapGetters({
      applicantCheckboxStatus: 'getApplicantCheckboxArchive',
      reloadApplicantHistoryTable: 'getReloadApplicantHistoryTable'
    }),
    paginationCurrentPage() {
      return this.pagination.currentPage
    },
    paginationPerPag() {
      return this.pagination.perPage
    },
    to() {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    isIndividual() {
      return this.$store.state.isIndividual
    }
  },
  methods: {
    formatDate(timestamp) {
      var m = moment(timestamp)
      return m.format('DD MMM YYYY')
    },
    getHistory: _.debounce(function () {
      this.paging = true
      this.history = []
      let historyRequest = {
        page: this.pagination.currentPage - 1,
        size: this.size,
        query: this.query,
        status: this.status,
        fromDate: this.dateRange[0],
        toDate: this.dateRange[1],
        customerReference: this.customerReference
      }
      this.$api.getApplicationHistory(historyRequest, this.customFilters)
        .then(response => {
          this.history = response.data.content
          this.pagination.total = response.data.totalSize
          this.total = response.data.totalSize
          this.paging = false
        })
        .catch(error => {
          this.paging = false
        })
    }, 500),
    selectApplication(row, column, event) {
      if (row && this.checkboxCol == false) {
        if (this.isIndividual) {
          this.$router.push('/application/history/' + row.id)
        } else {
          this.$router.push('/applicant/history/' + row.id)
        }
      } else if (event.target.type == "checkbox") {
        this.pushRowId(row)
      }
    },
    pushRowId(row) {
      if (this.$store.state.applicantSelectedRows.includes(row.id)) {
        this.$store.state.applicantSelectedRows.splice(this.$store.state.applicantSelectedRows.indexOf(row.id), 1)
      } else {
        this.$store.state.applicantSelectedRows.push(row.id)
      }
    }
  }
}
</script>
<style>

</style>
